module.exports = __webpack_public_path__ + "img/photoOrderLogin.762c5b2e.jpg";